// extracted by mini-css-extract-plugin
export default {"loaderBox":"styles_loaderBox__ojScV","loader":"styles_loader__AEGUL","spin":"styles_spin__AQc9b"};